/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.OnlineBookingSettings {
    angular.module("meevo.plugins.onlineBookingSettings", []);
}